import { cn } from '@/lib/utils';
import { Headphones, ShieldCheck, Tag, TicketCheck, type LucideIcon } from 'lucide-react';

interface TrustItem {
  icon: LucideIcon;
  title: string;
  note: string;
}

/**
 * Replaces HowItWorksSection + WhyChooseUsSection — two full-height sections of
 * icon circles — with one tight band. Every claim here is something the platform
 * actually does; the puffery ("trải nghiệm đỉnh cao", "giá tốt nhất thị trường")
 * is deliberately gone.
 */
const ITEMS: TrustItem[] = [
  { icon: TicketCheck, title: 'Vé điện tử tức thì', note: 'Nhận vé qua email ngay sau thanh toán' },
  { icon: ShieldCheck, title: 'Thanh toán bảo mật', note: 'Cổng thanh toán được mã hoá' },
  { icon: Headphones, title: 'Hỗ trợ 24/7', note: 'Đội ngũ tư vấn luôn sẵn sàng' },
  { icon: Tag, title: 'Ưu đãi thường xuyên', note: 'Mã giảm giá cập nhật liên tục' },
];

export function TrustStrip({ className }: { className?: string }) {
  return (
    <section className={cn('border-y border-gray-100 bg-white', className)} aria-label="Cam kết dịch vụ">
      <div className="container mx-auto max-w-7xl px-4 py-5 md:py-7">
        <ul className="grid grid-cols-2 gap-x-6 gap-y-4 md:grid-cols-4">
          {ITEMS.map(({ icon: Icon, title, note }) => (
            <li key={title} className="flex items-start gap-3">
              <span className="bg-primary/10 flex size-9 shrink-0 items-center justify-center rounded-lg">
                <Icon className="text-primary size-[18px]" aria-hidden="true" />
              </span>
              <div className="min-w-0">
                <p className="text-sm font-semibold text-gray-900">{title}</p>
                <p className="text-xs leading-snug text-gray-500">{note}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
